import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import { NewPasswordView } from '@/modules/auth'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/new-password')({
  beforeLoad: ({ context }) => {
    if (context.authStore?.isAuthenticated) {
      throw redirect({
        to: '/',
        replace: true
      })
    }
  },
  validateSearch: z.object({
    token: z.string().catch('')
  }),
  component: NewPasswordView,
  head: () =>
    getMetaWithPageTitle([i18n.t('title.new-password', { ns: 'auth' })])
})
